module.exports = __webpack_public_path__ + "static/media/guide_2_2.651ec5b9.png";